import { useMemo } from "react";

export function useScheduleAlerts({
  eventsError,
  tagsError,
  exportError,
  hasInteracted,
  formatErrorMessage,
  onClearEventsError,
  onClearTagsError,
  onClearExportError,
}) {
  const showEventsError = eventsError && hasInteracted;
  const showTagsError = tagsError;
  const showExportError = exportError;

  return {
    showEventsError,
    showTagsError,
    showExportError,
    formatErrorMessage,
    onClearEventsError,
    onClearTagsError,
    onClearExportError,
    eventsError,
    tagsError,
    exportError,
  };
}
